/**
 * Get an array of Nodes based on a variety of inputs:
 * - Already an Array
 * - NodeList usually via document.query...
 * - A single HTMLElement Node
 * - a string treated as a query selector
 *
 * @param  {String} targets - see above
 * @return {Array}
 *
 * TODO
 * Array.from polyfill?
 */
export default function getArrayOfNodes(targets) {
  if (Array.isArray(targets)) return targets;else if (targets instanceof NodeList) return Array.from(targets);else if (targets instanceof HTMLElement) return [targets];else if (typeof targets === 'string') return Array.from(document.querySelectorAll(targets));else throw new Error('Could not convert to array of nodes');
}